import { filtersHelper } from '@/utils';
import { propertyModel } from '@/models/api/property.model';

export const properttyTenantedModel = (data) => ({
    ...propertyModel(data),
    tenanted: data.property_tenanted ? {
        uuid: data.property_tenanted.uuid,
        landlord: data.property_tenanted.landlord,
        purpose: data.property_tenanted.purpose,
        dateCommenced: data.property_tenanted.date_commenced,
        dateExpired: data.property_tenanted.date_expired,
        tenureYear: data.property_tenanted.tenure_year,
        rentalPayment: data.property_tenanted.rental_payment,
        isActive: data.property_tenanted.is_active,
        createdAt: filtersHelper.getDateFormat(data.property_tenanted.created_at),
        createdBy: data.property_tenanted.created_by,
        updatedAt: filtersHelper.getDateFormat(data.property_tenanted.updated_at),
        updatedBy: data.property_tenanted.updated_by,
        deletedAt: filtersHelper.getDateFormat(data.property_tenanted.deleted_at),
        deletedBy: data.property_tenanted.deleted_by,
    } : null,
});